export const snapGridHeightToRows = (
	wrapper: HTMLElement,
	rowHeight: number,
	onHeightChange: (height: number, scrollbarHeight: number) => void,
) => {
	const measure = () => {
		const grid = wrapper.querySelector<HTMLElement>(".MuiDataGrid-root");
		const scroller = wrapper.querySelector<HTMLElement>(
			".MuiDataGrid-virtualScroller",
		);
		if (!grid || !scroller) return;

		const topContainer = wrapper.querySelector<HTMLElement>(
			".MuiDataGrid-topContainer",
		);
		const bottomContainer = wrapper.querySelector<HTMLElement>(
			".MuiDataGrid-bottomContainer",
		);
		const horizontalScrollbar = wrapper.querySelector<HTMLElement>(
			".MuiDataGrid-scrollbar--horizontal",
		);

		const stickyHeight =
			(topContainer?.offsetHeight ?? 0) + (bottomContainer?.offsetHeight ?? 0);
		const scrollbarHeight = horizontalScrollbar?.offsetHeight ?? 0;
		const chrome =
			grid.offsetHeight - scroller.clientHeight + stickyHeight + scrollbarHeight;
		const available = wrapper.clientHeight;
		const fittingRows = Math.max(
			0,
			Math.floor((available - chrome) / rowHeight),
		);

		onHeightChange(chrome + fittingRows * rowHeight, scrollbarHeight);
	};

	const resizeObserver = new ResizeObserver(measure);
	resizeObserver.observe(wrapper);

	const mutationObserver = new MutationObserver(measure);
	const main = wrapper.querySelector(".MuiDataGrid-main");
	if (main) mutationObserver.observe(main, { childList: true });

	measure();

	return () => {
		resizeObserver.disconnect();
		mutationObserver.disconnect();
	};
};
